import { useTranslation } from 'react-i18next';
import { MakeupAdvisor } from 'autogen/translation-keys/trans-website-shared';
import ButtonWithSpinner from 'components/Button/ButtonWithSpinner';
import type IButtonWithSpinner from 'components/Button/shared/types/buttonWithSpinner';
import useOpenRevievePlugin from '../shared/initializeRevieveScript';

type RevieveMakeupAdvisorProps = Omit<IButtonWithSpinner, 'onClick'> & {
    onClick?: IButtonWithSpinner['onClick'];
};

function MakeupAdvisorButton(props: RevieveMakeupAdvisorProps) {
    const { ...buttonWithSpinnerProps } = props;
    const { onClick, children } = buttonWithSpinnerProps;

    const { t } = useTranslation();
    const openRevieve = useOpenRevievePlugin();

    return (
        <ButtonWithSpinner
            {...buttonWithSpinnerProps}
            onClick={async (event) => {
                await openRevieve({ type: 'MakeupAdvisor' });
                onClick?.(event);
            }}
        >
            {children || t(MakeupAdvisor)}
        </ButtonWithSpinner>
    );
}

export default MakeupAdvisorButton;
